export default __webpack_public_path__ + "static/media/spinner.f399c76d.gif";